import { useEffect, useState, useRef } from "react";
import { useParams, useHistory } from "react-router";

import Loader from "../loader";
import { getEndpoint } from "../helper";

export default function ProductGallery({ }) {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [videoStatus, setVideoStatus] = useState({});

    const history = useHistory();

    const videoRefs = useRef({});
    const slickRef = useRef(null);
    const slickNavRef = useRef(null);
    const isFirstLoadRef = useRef(false);

    const { id, categoryId, slickIndex, isVideoFile } = useParams();

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch(getEndpoint(`/api/android/product/get?id=${id}&categoryId=${categoryId}`), { signal });
                const json = await response.json();
                setData(json.data);

            } catch (err) {
                if (err.name !== "AbortError") setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();

        document.body.classList.add('__full-screen__');

        return () => {
            document.body.classList.remove('__full-screen__');
            controller.abort();
        }
    }, []);

    useEffect(() => {
        if (!data || !data.gallery || data.gallery?.length == 0) return;

        $(slickRef.current).on('init', (e, slick) => {
            isFirstLoadRef.current = true;
            setTimeout(() => $(slickRef.current).slick('slickGoTo', slickIndex), 200);
        });

        $(slickRef.current).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            rtl: true,
            infinite: false
        });

        $(slickRef.current).on('beforeChange', (event, slick, current, next) => setCurrentSlide(next));

        $(slickRef.current).on('afterChange', (event, slick, current, next) => {
            if (isFirstLoadRef.current) {
                isFirstLoadRef.current = false;
                return;
            }

            for (const key in videoRefs.current) {
                if (!Object.hasOwn(videoRefs.current, key)) continue;

                videoRefs.current[key].pause();
            }
        });
    }, [data]);

    const isVideo = fileName => /\.(mp4|webm|ogg|mov)$/i.test(fileName);

    const getThumbnailPath = fileName => {
        if (isVideo(fileName)) return getEndpoint('/img/video_player.png');

        return getEndpoint(`/uploads/shop/product-file/${fileName}`);
    }

    const handleThumbnailClick = index => {
        $(slickRef.current).slick('slickGoTo', index);
    };

    const getThumbnailTranslate = () => {
        const total = data.gallery.length;

        if (total <= 3) return '0%';
        if (currentSlide <= 1) return '0%';
        if (currentSlide >= total - 1) return `${(total - 3) * 33.333}%`;

        return `${(currentSlide - 1) * 33.333}%`;
    };

    const getGalleryItem = (fileName) => {
        if (isVideo(fileName)) {
            const status = videoStatus[fileName] ?? "loading";

            return (
                <div>
                    {status === "loading" && (<div className='ta-c c-n5'>در حال بارگذاری ویدئو ...</div>)}

                    <video
                        className='w-100'
                        ref={(el) => { videoRefs.current[fileName] = el; }}
                        crossOrigin="anonymous"
                        src={getEndpoint(`/uploads/shop/product-file/${fileName}`)}
                        controls
                        autoPlay={isVideoFile === 'true'}
                        onCanPlay={() => {
                            setVideoStatus((prev) => ({
                                ...prev,
                                [fileName]: "loaded",
                            }));
                        }}
                        onError={() => {
                            setVideoStatus((prev) => ({
                                ...prev,
                                [fileName]: "error",
                            }));
                        }}
                    />
                </div>
            );
        }

        return <img src={getEndpoint(`/uploads/shop/product-file/${fileName}`)} />;
    };

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    return (
        <div className='bc-w p-r py-4 h-100 d-f fd-c'>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" className='mr-4' onClick={e => history.goBack()}>
                <path d="M25.313 7.031l-7.438 7.438 7.438 7.438-1.875 1.875-7.438-7.438-7.438 7.438-1.875-1.875 7.438-7.438-7.438-7.438 1.875-1.875 7.438 7.438 7.438-7.438z"></path>
            </svg>
            <div className='p-r my-a'>
                <div dir='rtl' className='full-screen'>
                    <div className='js__slick slick-main' ref={slickRef}>
                        {data.gallery.map((x, i) => (
                            <div className='d-b' key={i}>
                                {getGalleryItem(x)}
                            </div>
                        ))}
                    </div>
                    <div className='ta-c fw-600 fs-3 mt-8'>
                        {currentSlide + 1}/{data.gallery.length}
                    </div>
                    <div className='o-h'>
                        <div
                            className='d-f thumbnail-container'
                            style={{
                                transform: `translateX(${getThumbnailTranslate()})`,
                                transition: 'transform 0.35s ease'
                            }}
                        >
                            {data.gallery.map((x, i) => (
                                <div
                                    key={i}
                                    className={`thumbnail ${currentSlide === i ? 'active' : ''}`}
                                    onClick={() => handleThumbnailClick(i)}
                                >
                                    <img src={getThumbnailPath(x)} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}